import React from 'react';
import { ShieldCheck, FileText, ExternalLink, ScrollText } from 'lucide-react';

function TermsOfPolicy() {
  return (
    <div className="min-h-screen bg-parchment pt-16 font-serif">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <ScrollText className="h-16 w-16 text-parchment-dark" />
          </div>
          <h1 className="vintage-title">Terms of Policy</h1>
          <p className="vintage-subtitle max-w-3xl mx-auto">
            Understand our terms and conditions before using our platform.
          </p>
        </div>

        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <FileText className="h-6 w-6" />
            User Responsibility
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            Users are responsible for maintaining the confidentiality of their account credentials. We do not store your password; it is securely managed through your browser or third-party provider.
          </p>
        </div>

        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <FileText className="h-6 w-6" />
            Data Usage
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            We store only essential data:
          </p>
          <ul className="list-disc list-inside text-parchment-dark/80 mb-6 space-y-2">
            <li>Your email (used as a username).</li>
            <li>Search queries to provide dashboard history and insights.</li>
            <li>Quiz scores to enable personalized learning experiences.</li>
          </ul>
          <p className="text-parchment-dark/80 leading-relaxed">
            This data is never sold or shared and is used only to enhance your learning experience.
          </p>
        </div>

        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <FileText className="h-6 w-6" />
            Acceptable Use
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            You agree to use the platform respectfully and lawfully. Harassment, misuse of content, or any malicious activity will lead to account restriction or removal.
          </p>
        </div>

        <div className="vintage-card">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <FileText className="h-6 w-6" />
            Open Source Contribution
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            We are an open-source project, and we welcome contributions from the community. By contributing, you agree that your input can be used under the platform’s open-source license.
          </p>
          {/* <a href="/policy" className="inline-flex items-center gap-2 text-parchment-dark hover:text-parchment-dark/80 transition-colors">
            Read Privacy Policy
            <ExternalLink className="h-4 w-4" />
          </a> */}
        </div>
      </div>
    </div>
  );
}

export { TermsOfPolicy };
